// import {s360ConfigService} from "./Simplify360Chat/Services/S360Config";

import { s360ConfigService } from "./S360Config";
import HWUser from "../HWLibrary/HWUser";
import xmppService from "./XMPPService";
import { isNullOrUndefined } from "../HWLibrary/HWUtils";

const watchForChatSDKEvents = (appComponent, onDateRefresh) => {
  window.addEventListener(
    "message",
    (messageEvent) => {
      // console.log("as", messageEvent);
      if (
        !s360ConfigService.isClientHostConfigured() ||
        messageEvent.origin !== s360ConfigService.sourceOrigin
      )
        return;
      // console.log(messageEvent.data);

      try {
        let messageData = JSON.parse(messageEvent.data);
        if (
          !messageData ||
          messageData.clientHostId !== s360ConfigService.clientHostId ||
          !messageData.action
        ) {
          return;
        }
        // console.log("Data: ");
        // console.log("jj", messageData);
        switch (messageData.action) {
          case "on-update-user-metadata":
            s360ConfigService.sendUserData(messageData.data);
            break;
          case "on-config-data-update":
            //STEP 6
            s360ConfigService.setConfig(messageData.data);
            break;
          case "on-agent-data-update":
            if (!!messageData.data?.agentConnected) {
              localStorage.setItem("agentConnected", true);
              localStorage.setItem("agentName", messageData.data.agentName);
            }
            break;
          case "on-URL-data-update":
            s360ConfigService.setURLParams(messageData.data);
            break;
          case "on-reset-user":
            onResetUser(onDateRefresh);
            break;
          case "chat-maximize":
            appComponent.setState({
              chatMaximized: !appComponent.state.chatMaximized,
            });
            break;
          case "chat-scroll":
            scrollConversationPage();
            break;
          case "on-set-user-config":
            {
              s360ConfigService.setUserConfig(messageData.data);
              appComponent.setState({ user: JSON.stringify(messageData.data) });
            }
            break;
          // case "remove-login":
          //  {
          //  appComponent.removeLoginFunction()}
          //   break;
          // case "on-chat-toggle": appComponent.onStartUpClick(); break;
          default:
            break;
        }
      } catch (error) {
        console.log("Invalid Message Data: ");
      }

      appComponent.setState({ refreshKey: new Date().toISOString() });
    },
    false,
  );
};

const onResetUser = (onDateRefresh) => {
  if (!s360ConfigService.config.configDetails?.restartConvWithoutReset)
    HWUser.resetUser();

  onDateRefresh && onDateRefresh();

  window.location.reload();
  // sessionStorage.removeItem("user-config")
};

// TODO: need to remove if not working
const scrollConversationPage = () => {
  const convPage = document.getElementById("conver")?.firstChild;

  if (convPage)
    convPage.scrollTo({
      top: convPage.scrollHeight,
      behavior: "smooth",
    });
};

const postPlatformMessage = (messageData, actionName) => {
  //STEP3
  // if(!s360ConfigService.isClientHostConfigured() || !s360ConfigService.sourceOrigin) { return; }
  let message = {
    data: messageData,
    action: actionName,
    clientHostId: s360ConfigService.clientHostId,
  };
  try {
    window.parent.postMessage(JSON.stringify(message), "*");
  } catch (error) {
    console.log(error);
  }
};

const fetchConfigDetailsFromClientHost = () => {
  //STEP2
  postPlatformMessage(null, "update-client-host-config");
};
const checkChangeInConfig = () => {
  postPlatformMessage(null, "check-config-diffrence");
};
const loadLocalUser = () => {
  postPlatformMessage(null, "load-local-user");
};
const sendOnAppOpen = () => {
  postPlatformMessage(null, "on-app-open");
};

const sendOnAppClose = () => {
  postPlatformMessage(null, "on-app-close");
};

const resetRestartButtonFlag = () => {
  postPlatformMessage(null, "reset-restart-button-flag");
};

const sendNotification = (payload) => {
  postPlatformMessage(payload, "notification");
};

const requestNotificationPermission = () => {
  postPlatformMessage(null, "request-notification-permission");
};

export {
  watchForChatSDKEvents,
  fetchConfigDetailsFromClientHost,
  sendOnAppOpen,
  sendOnAppClose,
  checkChangeInConfig,
  loadLocalUser,
  resetRestartButtonFlag,
  sendNotification,
  requestNotificationPermission,
};
